var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 18.83C31.5 10.595 25.11 5 18 5C10.965 5 4.5 10.475 4.5 18.92C3.6 19.43 3 20.39 3 21.5V24.5C3 26.15 4.35 27.5 6 27.5C6.825 27.5 7.5 26.825 7.5 26V18.785C7.5 13.04 11.925 8.015 17.67 7.85C23.61 7.67 28.5 12.44 28.5 18.35V29H18C17.175 29 16.5 29.675 16.5 30.5C16.5 31.325 17.175 32 18 32H28.5C30.15 32 31.5 30.65 31.5 29V27.17C32.385 26.705 33 25.79 33 24.71V21.26C33 20.21 32.385 19.295 31.5 18.83Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21.5C14.3284 21.5 15 20.8284 15 20C15 19.1716 14.3284 18.5 13.5 18.5C12.6716 18.5 12 19.1716 12 20C12 20.8284 12.6716 21.5 13.5 21.5Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21.5C23.3284 21.5 24 20.8284 24 20C24 19.1716 23.3284 18.5 22.5 18.5C21.6716 18.5 21 19.1716 21 20C21 20.8284 21.6716 21.5 22.5 21.5Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 17.045C26.28 12.77 22.56 9.5 18.075 9.5C13.53 9.5 8.63995 13.265 9.02995 19.175C12.735 17.66 15.525 14.36 16.32 10.34C18.285 14.285 22.32 17 27 17.045Z",
    fill: "#5A5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/SupportIcon.6a7005c6776a74d2d2289786fbb2a4ee.svg";
export { ForwardRef as ReactComponent };